exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container[data-v-54187a52]{padding:18px 5px 0 5px}.container .text_area[data-v-54187a52]{font-size:18px;text-align:center}.container .btn_area[data-v-54187a52]{display:flex;justify-content:center}", ""]);

